import {AxiosPromise, AxiosResponse} from 'axios';
import api from './api';
import {Team} from '../interfaces';

export function getCurrentTeams() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get('/teams/current')
        .then((response: AxiosResponse<{teams: Team[]}>) => {
          resolve(response as unknown as AxiosPromise<{teams: Team[]}>);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
